import type { IntradayOrderRow } from '~/hooks/bidding/useListBiddingIntradayOrders'
import { isUnknownIssuerLicenseType } from '~/models/bidIssuerType'
import { isSameProtoDate, toProtoDate } from '~/models/dateTime'
import { uniqueDeliveryContractCodes } from '~/models/unknownIssuerBid'

/**
 * 警告 (AC-BIN-109a) に並べる受渡契約コード。 表示中の受渡日の注文のうち、 発注主体区分が
 * 空欄のものから集める。 ステータスは問わない (#10084)。
 */
export const intradayUnknownIssuerDeliveryContractCodes = (
  orders: readonly IntradayOrderRow[],
  targetDate: Date,
): string[] => {
  const target = toProtoDate(targetDate)
  return uniqueDeliveryContractCodes(
    orders
      .filter(
        (o) =>
          isSameProtoDate(o.targetDate, target) &&
          isUnknownIssuerLicenseType(o.issuerType),
      )
      .map((o) => o.deliveryContractCd),
  )
}
